import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { PageLayout, DefaultButton } from 'common/components';
import { withTheme } from 'common/styling/theme';

import noPartnersImage from 'common/images/noPartners.svg';

import { requestPartnership } from '../../_redux';

import { staticStyles, getDynamicStyles } from './style';

const PartnershipPage = ({ profile, requestEasyStartState, requestEasyStartIsSending, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const [isLoading, setLoading] = useState(false);
  const history = useHistory();
  const isVerified = profile.status === 'verified';
  const isContractPending = profile.isIbContractPending;
  const handleBecomePartner = () => {
    history.push('/partnership/become_introducing_broker');
  };

  useEffect(() => {
    setLoading(requestEasyStartIsSending);

    if (requestEasyStartState) {
      history.push('/partnership/links');
    }
  }, [requestEasyStartState, requestEasyStartIsSending, history]);

  return (
    <PageLayout captionSlug="partnershipPage">
      <div className="PartnershipPage">
        <div className="PartnershipPage__top-inner">
          <img src={noPartnersImage} alt="Partner" />
          {isVerified ? (
            <>
              <FormattedMessage id="partnershipPanelCaption">{txt => <h3>{txt}</h3>}</FormattedMessage>
              <FormattedMessage id="partnershipConditionsAfterApplication">{txt => <p>{txt}</p>}</FormattedMessage>
            </>
          ) : (
            <FormattedMessage id="validationErrorUserShouldBeVerified">{txt => <h3>{txt}</h3>}</FormattedMessage>
          )}
        </div>

        {isContractPending ? (
          <div className="PartnershipPage__button-inner">
            <DefaultButton
              type="button"
              onClick={() => history.push('/partnership/ib-contract')}
              textId="partnershipSignNow"
              filled
              loading={isLoading}
            />
          </div>
        ) : profile.isPartnershipRequested || requestEasyStartIsSending ? (
          <div className="PartnershipPage__inner">
            <FormattedMessage id="partnershipPanelRequestText">{txt => <p>{txt}</p>}</FormattedMessage>

            <NavLink to="support">
              <FormattedMessage id="partnershipPanelRequestLink" />
            </NavLink>
          </div>
        ) : (
          isVerified && (
            <div className="PartnershipPage__button-inner">
              <DefaultButton
                type="button"
                onClick={handleBecomePartner}
                textId="partnershipPanelButtonText"
                filled
                loading={isLoading}
              />
            </div>
          )
        )}

        <style jsx>{staticStyles}</style>
        <style jsx>{dynamicStyles}</style>
      </div>
    </PageLayout>
  );
};

PartnershipPage.propTypes = {
  profile: PropTypes.object.isRequired,
  requestEasyStartState: PropTypes.bool.isRequired,
  requestEasyStartIsSending: PropTypes.bool.isRequired,
  theme: PropTypes.object,
};

PartnershipPage.defaultProps = {
  theme: {},
};

const ThemedPartnershipPage = withTheme()(PartnershipPage);

export default connect(
  state => ({
    profile: state.user.profile,
    requestEasyStartState: state.client.partnership.requestEasyStart,
    requestEasyStartIsSending: state.client.partnership.requestEasyStartIsSending,
  }),
  {
    requestPartnership: () => requestPartnership.request(),
  }
)(ThemedPartnershipPage);
export { PartnershipPage };
